import HeaderNavParent from './HeaderNavParent'; // eslint-disable-line import/no-cycle

export default class HeaderNavMenu {
  constructor(options) {
    this.navList = options.navList;
    this.menuItems = this.navList.children;

    this.parents = [];

    this.abortController = new AbortController();

    for (let i = 0; i < this.menuItems.length; i++) {
      const menuItem = this.menuItems[i];
      if (menuItem.dataset.headerNavParent !== undefined) {
        this.parents.push(
          new HeaderNavParent({
            menuItem,
            parentMenu: this,
          }),
        );
      } else {
        // If the keyboard navigation moves to another menuItem, we should close any
        // other existing menus that are open.
        menuItem.addEventListener('focusin', () => this.closeAllMenus(), { signal: this.abortController.signal });
      }
    }
  }

  // This function will close all menus that are not the current menu.
  // This is mostly used by the HeaderNavParent class.
  closeSiblings(current) {
    this.parents.forEach(parent => {
      if (parent !== current) {
        parent.close();
      }
    });
  };

  closeAllMenus() {
    this.parents.forEach(parent => parent.close());
  }

  unload() {
    this.parents.forEach(parent => { parent.unload(); });
    this.abortController.abort();
  }
}
